
import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConnectionErrorAlertProps {
  connectionError: string | null;
  dataSource: 'supabase' | 'mock';
  onRetry?: () => void;
}

export const ConnectionErrorAlert: React.FC<ConnectionErrorAlertProps> = ({ 
  connectionError, 
  dataSource,
  onRetry
}) => {
  // Если данные успешно загружаются из Supabase, не показываем уведомление
  if (dataSource === 'supabase' || !connectionError) return null;

  return (
    <div className="p-4 mb-4 bg-muted/30 border rounded-md">
      <div className="flex items-start">
        <AlertCircle className="h-5 w-5 text-muted-foreground mt-0.5 mr-2" />
        <div className="flex-1">
          <p className="font-medium text-sm">
            Используются тестовые данные
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            {connectionError}
          </p>
          {onRetry && (
            <div className="mt-3">
              <Button 
                size="sm"
                variant="outline"
                onClick={onRetry}
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Обновить данные
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
